import hatsApi from '@/services/hatsApi'

export default {
  getLedgers (filters = '', pageSize = '', currentPage = '') {
    let pagination = pageSize ? '&pageSize=' + pageSize : ''
    pagination += currentPage ? '&page=' + currentPage : ''

    return hatsApi().get(
      `/master-data/ledger?filter=${JSON.stringify(filters)}${pagination}`
    )
  },
  getLedgersForDropdown (filters = '') {
    return hatsApi().get(
      `/master-data/ledger/dropdown?filter=${JSON.stringify(filters)}`
    )
  },
  createLedger (params) {
    return hatsApi().post('/master-data/ledger', params)
  },
  editLedger (id, params) {
    return hatsApi().put(`/master-data/ledger/${id}`, params)
  },
  deleteLedger (id) {
    return hatsApi().delete(`/master-data/ledger/${id}`)
  },
  getLedgerById (id) {
    return hatsApi().get(`/master-data/ledger/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Ledger.js